import type { GatewayDescriptor } from "../paymentGatewayDescriptors";

type Props = {
  descriptor: GatewayDescriptor;
  size?: "sm" | "md";
};

// Inline SVG brand badge — a rounded rect in the gateway's accent colour with
// its initials, the same approach as JntLogo. We don't reproduce the gateways'
// trademarked logo artwork; this is a clean, generic letter mark that renders
// immediately with no external asset.
export function GatewayLogo({ descriptor, size = "md" }: Props) {
  const px = size === "sm" ? 28 : 36;
  const fontSize = descriptor.initial.length > 1 ? 22 : 28;
  return (
    <svg
      viewBox="0 0 64 64"
      width={px}
      height={px}
      role="img"
      aria-label={descriptor.provider}
      className="shrink-0"
    >
      <rect width="64" height="64" rx="14" fill={descriptor.brandColor} />
      <text
        x="32"
        y="41"
        textAnchor="middle"
        fontFamily="'Helvetica Neue', Helvetica, Arial, sans-serif"
        fontWeight="800"
        fontSize={fontSize}
        letterSpacing="-0.5"
        fill={descriptor.onDark ? "#FFFFFF" : "#1A1A1A"}
      >
        {descriptor.initial}
      </text>
    </svg>
  );
}
